<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="标注"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="false"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="标注">
          <el-input size="mini" v-model="params.MarkName" placeholder="请填写标注" clearable />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="Sn" label="序号"/>
        <el-table-column prop="MarkName" label="标注" />
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/analyse/mark").default,
      params: {
        MarkName: "",
      },
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  },
};
</script>